import { useTranslations } from 'next-intl'
import { chakra, Stack, Text, Flex } from '@chakra-ui/react'

import { ContainerBase } from '../../components/containers/ContainerBase'
import { ShieldIcon } from '@/components/icons/ShieldIcon'

export function FacilitiesHero() {
  const t = useTranslations()
  return (
    <Stack
      py={{ base: 5, md: 10, lg: '2.4rem' }}
      direction={{ base: 'column', lg: 'row' }}
      bg={'black'}
      backgroundRepeat="no-repeat"
      minW={{ base: 'unset' }}
    >
      <ContainerBase display="flex" justifyContent="center">
        <Stack
          zIndex={1}
          direction="column"
          justifyContent="center"
          spacing={6}
          maxW="800px"
        >
          <Flex color="brand.600" justifyContent="center">
            <ShieldIcon
              backgroundColor={`brand.transparent30`}
              w={`64px`}
              h={`64px`}
              rounded={`12`}
            />
          </Flex>
          <chakra.h1
            fontSize={{ base: '4xl', lg: '6xl' }}
            lineHeight={1}
            fontWeight="bold"
            textAlign="center"
            color={'white'}
          >
            {t.rich('facilities-list.slogan-title', {
              bold: (children) => (
                <Text as="span" color={'brand.600'}>
                  {children}
                </Text>
              ),
            })}
            <br />
          </chakra.h1>
          <Text
            fontSize={{ base: '1.3rem', lg: '1.6rem' }}
            textAlign="center"
            lineHeight="1.375"
            fontWeight="400"
            color={'gray.500'}
            px={{ base: '26px', lg: '2' }}
          >
            {/* {t('facilities-list.slogan-description')} */}
            {t.rich('facilities-list.slogan-description', {
              bold: (children) => (
                <Text as="span" color={'gray.300'}>
                  {children}
                </Text>
              ),
            })}
          </Text>
        </Stack>
      </ContainerBase>
    </Stack>
  )
}
